import { Button, Loader } from "@coval/ui"
import { Check, CircleAlert, Clock3, MessageSquare } from "lucide-react"

import type { ReportSectionProgress } from "../../utils/reportRevisionTypes"
import { reportClass } from "./ReportStyles"

export function SectionRevision({
  targetId,
  title,
  progress,
  onRevise,
  disabled,
}: {
  targetId: string
  title: string
  progress?: ReportSectionProgress
  onRevise?: (id: string) => void
  disabled: boolean
}) {
  const status = progress?.status
  const labels = {
    queued: "Queued for this section",
    running: "Updating this section",
    saved: progress?.revision
      ? `Saved · revision ${progress.revision}`
      : "Saved",
    unchanged: "No changes needed",
    failed: "Request failed · saved content preserved",
  }
  if (!onRevise && !progress) {
    return null
  }
  return (
    <div className={reportClass("section-revision")}>
      {status && (
        <div
          className={reportClass(`revision-status revision-${status}`)}
          role={status === "failed" ? "alert" : "status"}
          aria-label={`${title} revision status`}
        >
          {status === "running" ? (
            <Loader size="sm" aria-hidden="true" />
          ) : status === "queued" ? (
            <Clock3 size={13} />
          ) : status === "failed" ? (
            <CircleAlert size={13} />
          ) : (
            <Check size={13} />
          )}
          <span>
            {labels[status]}
            {progress.message && <small>{progress.message}</small>}
          </span>
        </div>
      )}
      {onRevise && (
        <Button
          variant="ghost"
          className={reportClass("revise-section-button")}
          aria-label={`Revise ${title}`}
          disabled={disabled}
          onClick={() => onRevise(targetId)}
        >
          <MessageSquare />
          {targetId === "__overview__"
            ? "Revise overview"
            : "Revise this section"}
        </Button>
      )}
    </div>
  )
}
